const RATE_FORMATTER = new Intl.NumberFormat("en-US", {
  maximumSignificantDigits: 3,
});

const MAX_LATEST_ARC_DURATION_MS = 700;
const MAX_TERM_SOUND_DURATION_MS = 260;
const MIN_TIMED_EFFECT_DURATION_MS = 40;

function assertTickMs(tickMs: number): void {
  if (!Number.isFinite(tickMs) || tickMs <= 0) {
    throw new RangeError("tickMs must be a positive finite number");
  }
}

export function formatTermRate(tickMs: number): string {
  assertTickMs(tickMs);
  const termsPerSecond = 1_000 / tickMs;
  const unit = termsPerSecond === 1 ? "term" : "terms";
  return `${RATE_FORMATTER.format(termsPerSecond)} ${unit} / sec`;
}

function durationWithinTick(
  tickMs: number,
  ratio: number,
  maximumMs: number,
): number {
  assertTickMs(tickMs);
  return Math.min(
    maximumMs,
    Math.max(MIN_TIMED_EFFECT_DURATION_MS, tickMs * ratio),
    tickMs * 0.9,
  );
}

export function latestArcDurationForTick(tickMs: number): number {
  return durationWithinTick(tickMs, 0.8, MAX_LATEST_ARC_DURATION_MS);
}

export function termSoundDurationForTick(tickMs: number): number {
  return durationWithinTick(tickMs, 0.72, MAX_TERM_SOUND_DURATION_MS);
}
